import useHeaderCityObserver from '@hooks/useHeaderCityObserver'

export default {
  data: () => ({
    headerCityObserver: null,
  }),

  watch: {
    cityId() {
      if (this.headerCityObserver) window.setSessionCity(this.cityId)
    },
  },

  methods: {
    setSessionCity(id) {
      if (window.setSessionCity) window.setSessionCity(id, false) // новый id города, редирект
    },
    observeHeaderCity() {
      // Наблюдаем изменение города в header
      this.headerCityObserver = useHeaderCityObserver(cityId => this.changeCity(cityId))
    },
    stopObserveHeaderCity() {
      if (this.headerCityObserver) this.headerCityObserver.disconnect()
    },
  },

  mounted() {
    this.observeHeaderCity()
  },

  beforeDestroy() {
    this.stopObserveHeaderCity()
  },
}
